module.exports = __webpack_public_path__ + "static/media/delete-message.32620a66.svg";